import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmPopupViewedPayload {
  professionalId?: string;
  candidateId?: string;
  shiftId?: string;
  offerId?: string;
}

/**
 * Fires when the "review additional applications" popup is shown after confirming a candidate.
 *
 * `shiftId` / `offerId` identify the shift and offer that were *just confirmed* and
 * triggered the popup. `candidate_count` is 1 — this popup is about a single
 * professional. No shift_count: the professional's other pending shifts aren't
 * loaded until the bulk page opens (GOTU-4815).
 *
 * Event: dental_portal:bulk_confirm:popup_viewed
 */
export function fireBulkConfirmPopupViewed(payload: IBulkConfirmPopupViewedPayload = {}): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:popup_viewed', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_id: payload.shiftId,
    offer_id: payload.offerId,
    candidate_count: 1,
  });
}
